class BlockTextImage {
	constructor() {
		this.blocks = document.querySelectorAll(".block-text-image[data-color]");
		if (this.blocks) {
			this.customAccentColor();
		}
	}

	customAccentColor() {
		this.blocks.forEach(block => {
			const color = block.dataset.color;

			const btns = block.querySelectorAll(".btn");
			btns.forEach(btn => {
				btn.style.backgroundColor = color;

				btn.addEventListener("mouseenter", () => {
					btn.querySelector("svg").style.fill = color;
				});

				btn.addEventListener("mouseleave", () => {
					btn.querySelector("svg").style.fill = "#ffffff";
				});
			});

			const spans = block.querySelectorAll("span.accent-text");
			spans.forEach(span => {
				span.style.color = color;
			});
		});
	}

	frameParallax() {
		const ratio = 25;
		this.pictures.forEach(frame => {
			const image = frame.querySelector("img");
			frame.style.width = frame.clientWidth + "px";
			frame.style.height = frame.clientHeight + "px";
			image.style.height = image.clientHeight * (ratio / 100 +1) + "px";
			image.style.transform = "translateY(-" + ratio + "px";
			gsap.to(image, {
				y: '0',
				ease: 'none',
				scrollTrigger: {
					trigger: frame,
					start: 'top bottom',
					end: 'bottom top',
					scrub: 1
				}
			});
		});
	}
}